import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { useFeedback } from '../context/FeedbackContext';

const FloatingButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 20px; /* Left side to avoid conflict with other chatbots/widgets */
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1fa2ff 0%, #12d8fa 100%); /* Modern gradient */
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 9998; /* Just below modal overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    bottom: 70px; /* Move up on mobile to avoid bottom nav/tabs if any */
  }
`;

const FeedbackButton = () => {
    const { showFeedback } = useFeedback();

    return (
        <FloatingButton
            onClick={() => showFeedback('manual_button', { force: true })}
            aria-label="Give Feedback"
            title="Give Feedback"
        >
            <FontAwesomeIcon icon={faCommentDots} />
        </FloatingButton>
    );
};

export default FeedbackButton;
